export enum PackagePickupDirection {
  Any = 0,
  LengthSide = 1,
  WidthSide = 2,
}
